<template>
  <div class="Webpage-responsive w-100 h-100" ref="iframeContainer">
    <iframe
      :src="src"
      width="100%"
      height="2000px"
      allowFullScreen
      title="Embedded Website"
      @load="startScrolling" 
    />
  </div>
</template>

<script>
export default {
  name: 'WebpageApp',
  props: {
    src: String,
    scrollSpeed: {
      type: Number, // Ensure it's a number
      default: 50,  // Default scroll speed
    },
  },
  watch: {
    scrollSpeed() {
      this.stopScrolling(); // Stop any previous scrolling
      this.startScrolling(); // Restart scrolling with updated speed
    },
  },
  methods: {
    startIframeScroll() {
      const container = this.$refs.iframeContainer;
      
      // Check if the container has reached the bottom
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
        // Reset scroll immediately to the top without attempting to scroll down further
        container.scrollTo({ top: 0, behavior: 'auto' });
      } else {
        // Scroll the container by the scrollSpeed dynamically
        container.scroll({
          top: container.scrollTop + this.scrollSpeed, // Use the number scrollSpeed
          behavior: 'smooth', // Ensure smooth scrolling
        });
      }
    },

    startScrolling() {
      // Adjust this time interval to control scroll speed
      this.scrollInterval = setInterval(() => {
        this.startIframeScroll();
      }, 100); // Call the scroll every 100ms (lower means faster scroll)
    },

    stopScrolling() {
      // Stop scrolling by clearing the interval
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
  },
  beforeDestroy() {
    // Clear the interval if component is destroyed
    this.stopScrolling();
  },
};
</script>

<style scoped>
.Webpage-responsive {
  height: 100%; /* Set the container height */
  overflow-y: auto; /* Enable scrolling inside the container */
}
</style>
